export { default } from './RelatedRecordsTable';
